module.exports = __webpack_public_path__ + "media/leipzig/universities-map-leipzig-7d17858b.webp";